// 物件コード（UUID）の書式検証・正規化。
// フロントは値を解釈・加工せず、書式のみ検証する。
// ※バージョン桁の厳格判定はしない（契約サンプルが v4 形式のため）。最終判定はサーバ側（400）でも行われる。

const UUID_REGEX =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/**
 * 物件コード文字列を検証する。UUID 書式なら同値、未指定（null）・書式不正なら null を返す。
 * @param rawCode クエリパラメータ等から取得した生の物件コード（未指定時 null）
 * @example
 * parsePropertyCode("771449a9-94c3-43da-9be4-1088990cf966") // "771449a9-94c3-43da-9be4-1088990cf966"
 * parsePropertyCode("invalid") // null
 */
export const parsePropertyCode = (rawCode: string | null): string | null =>
  rawCode != null && UUID_REGEX.test(rawCode) ? rawCode : null;
